import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerShipToAddressStyles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import { css } from "styled-components";

headerShipToAddressStyles.titleClickable = mergeToNew(headerShipToAddressStyles.titleClickable, {
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
});
